import * as React from 'react';
import { compose } from 'redux';
import { reduxForm } from 'redux-form';
import type { InjectedFormProps } from 'redux-form';

import EmailForm from './EmailForm';
import { EmailContactFM } from './formModel';

interface OwnProps {
	toggleEditInputOff: () => void;
	updateEmailContact: (form: EmailContactFM) => Promise<void>;
	initialValues?: Partial<EmailContactFM>;
	form: string;
}

type Props = OwnProps & InjectedFormProps<EmailContactFM, OwnProps>;

const EmailEdit: React.FC<Props> = (props) => {

	const {
		toggleEditInputOff,
		updateEmailContact,
	} = props;

	const handleUpdateEmailContact = React.useCallback(async (form: EmailContactFM) => {
		await updateEmailContact(form);
	}, [updateEmailContact]);

	return (
		<EmailForm
			onSubmit={handleUpdateEmailContact}
			toggleInputEditOff={toggleEditInputOff}
			{...props}
		/>
	);
};

const enhance = compose<React.ComponentType<OwnProps>>(
	React.memo,
	reduxForm<EmailContactFM, OwnProps>({
		validate: EmailContactFM.validate,
		enableReinitialize: true,
	})
);

export default enhance(EmailEdit);
